import { grpcBaseUrl } from './config';

const { DashboardServicePromiseClient } = require('./proto/acompanha/dashboard/v1/dashboard_grpc_web_pb.js');
const { AuthServicePromiseClient } = require('./proto/acompanha/auth/v1/auth_grpc_web_pb.js');
const { AccountServicePromiseClient } = require('./proto/acompanha/account/v1/account_grpc_web_pb.js');
const { JobsServicePromiseClient } = require('./proto/acompanha/jobs/v1/jobs_grpc_web_pb.js');
const { PrintersServicePromiseClient } = require('./proto/acompanha/printers/v1/printers_grpc_web_pb.js');
const { FilamentsServicePromiseClient } = require('./proto/acompanha/filaments/v1/filaments_grpc_web_pb.js');
const { SalesChannelsServicePromiseClient } = require('./proto/acompanha/sales_channels/v1/sales_channels_grpc_web_pb.js');
const { PaymentFeesServicePromiseClient } = require('./proto/acompanha/payment_fees/v1/payment_fees_grpc_web_pb.js');
const { ProductsServicePromiseClient } = require('./proto/acompanha/products/v1/products_grpc_web_pb.js');
const { CustomersServicePromiseClient } = require('./proto/acompanha/customers/v1/customers_grpc_web_pb.js');
const { CheckoutsServicePromiseClient } = require('./proto/acompanha/checkouts/v1/checkouts_grpc_web_pb.js');
const { QuotesServicePromiseClient } = require('./proto/acompanha/quotes/v1/quotes_grpc_web_pb.js');
const { OrdersServicePromiseClient } = require('./proto/acompanha/orders/v1/orders_grpc_web_pb.js');
const { TransactionsServicePromiseClient } = require('./proto/acompanha/transactions/v1/transactions_grpc_web_pb.js');
const { PrinterMaintenancesServicePromiseClient } = require('./proto/acompanha/printer_maintenances/v1/printer_maintenances_grpc_web_pb.js');
const { AppNotificationsServicePromiseClient } = require('./proto/acompanha/app_notifications/v1/app_notifications_grpc_web_pb.js');
const { DesktopReleasesServicePromiseClient } = require('./proto/acompanha/desktop_releases/v1/desktop_releases_grpc_web_pb.js');
const { TicketsServicePromiseClient } = require('./proto/acompanha/tickets/v1/tickets_grpc_web_pb.js');
const { ReplacementPartsServicePromiseClient } = require('./proto/acompanha/replacement_parts/v1/replacement_parts_grpc_web_pb.js');
const { OperationalCostsServicePromiseClient } = require('./proto/acompanha/operational_costs/v1/operational_costs_grpc_web_pb.js');
const { TutorialVideosServicePromiseClient } = require('./proto/acompanha/tutorial_videos/v1/tutorial_videos_grpc_web_pb.js');
const { PrinterModelsServicePromiseClient } = require('./proto/acompanha/printer_models/v1/printer_models_grpc_web_pb.js');
const { FeatureFlagsServicePromiseClient } = require('./proto/acompanha/feature_flags/v1/feature_flags_grpc_web_pb.js');
const { SubscriptionBillingServicePromiseClient } = require('./proto/acompanha/subscription_billing/v1/subscription_billing_grpc_web_pb.js');
const { SubscriptionPlansServicePromiseClient } = require('./proto/acompanha/subscription_plans/v1/subscription_plans_grpc_web_pb.js');
const { CommercePartnersServicePromiseClient } = require('./proto/acompanha/commerce_partners/v1/commerce_partners_grpc_web_pb.js');
const { UsersServicePromiseClient } = require('./proto/acompanha/users/v1/users_grpc_web_pb.js');

const host = () => grpcBaseUrl();

let dashboard;
let auth;
let account;
let jobs;
let printers;
let filaments;
let salesChannels;
let paymentFees;
let products;
let customers;
let checkouts;
let quotes;
let orders;
let transactions;
let printerMaintenances;
let appNotifications;
let desktopReleases;
let tickets;
let replacementParts;
let operationalCosts;
let tutorialVideos;
let printerModels;
let featureFlags;
let subscriptionBilling;
let subscriptionPlans;
let commercePartners;
let users;

export function dashboardClient() {
    if (!dashboard) {
        dashboard = new DashboardServicePromiseClient(host(), null, null);
    }
    return dashboard;
}

export function authClient() {
    if (!auth) {
        auth = new AuthServicePromiseClient(host(), null, null);
    }
    return auth;
}

export function accountClient() {
    if (!account) {
        account = new AccountServicePromiseClient(host(), null, null);
    }
    return account;
}

export function jobsClient() {
    if (!jobs) {
        jobs = new JobsServicePromiseClient(host(), null, null);
    }
    return jobs;
}

export function printersClient() {
    if (!printers) {
        printers = new PrintersServicePromiseClient(host(), null, null);
    }
    return printers;
}

export function filamentsClient() {
    if (!filaments) {
        filaments = new FilamentsServicePromiseClient(host(), null, null);
    }
    return filaments;
}

export function salesChannelsClient() {
    if (!salesChannels) {
        salesChannels = new SalesChannelsServicePromiseClient(host(), null, null);
    }
    return salesChannels;
}

export function paymentFeesClient() {
    if (!paymentFees) {
        paymentFees = new PaymentFeesServicePromiseClient(host(), null, null);
    }
    return paymentFees;
}

export function productsClient() {
    if (!products) {
        products = new ProductsServicePromiseClient(host(), null, null);
    }
    return products;
}

export function customersClient() {
    if (!customers) {
        customers = new CustomersServicePromiseClient(host(), null, null);
    }
    return customers;
}

export function checkoutsClient() {
    if (!checkouts) {
        checkouts = new CheckoutsServicePromiseClient(host(), null, null);
    }
    return checkouts;
}

export function quotesClient() {
    if (!quotes) {
        quotes = new QuotesServicePromiseClient(host(), null, null);
    }
    return quotes;
}

export function ordersClient() {
    if (!orders) {
        orders = new OrdersServicePromiseClient(host(), null, null);
    }
    return orders;
}

export function transactionsClient() {
    if (!transactions) {
        transactions = new TransactionsServicePromiseClient(host(), null, null);
    }
    return transactions;
}

export function printerMaintenancesClient() {
    if (!printerMaintenances) {
        printerMaintenances = new PrinterMaintenancesServicePromiseClient(host(), null, null);
    }
    return printerMaintenances;
}

export function appNotificationsClient() {
    if (!appNotifications) {
        appNotifications = new AppNotificationsServicePromiseClient(host(), null, null);
    }
    return appNotifications;
}

export function desktopReleasesClient() {
    if (!desktopReleases) {
        desktopReleases = new DesktopReleasesServicePromiseClient(host(), null, null);
    }
    return desktopReleases;
}

export function ticketsClient() {
    if (!tickets) {
        tickets = new TicketsServicePromiseClient(host(), null, null);
    }
    return tickets;
}

export function replacementPartsClient() {
    if (!replacementParts) {
        replacementParts = new ReplacementPartsServicePromiseClient(host(), null, null);
    }
    return replacementParts;
}

export function operationalCostsClient() {
    if (!operationalCosts) {
        operationalCosts = new OperationalCostsServicePromiseClient(host(), null, null);
    }
    return operationalCosts;
}

export function tutorialVideosClient() {
    if (!tutorialVideos) {
        tutorialVideos = new TutorialVideosServicePromiseClient(host(), null, null);
    }
    return tutorialVideos;
}

export function printerModelsClient() {
    if (!printerModels) {
        printerModels = new PrinterModelsServicePromiseClient(host(), null, null);
    }
    return printerModels;
}

export function featureFlagsClient() {
    if (!featureFlags) {
        featureFlags = new FeatureFlagsServicePromiseClient(host(), null, null);
    }
    return featureFlags;
}

export function subscriptionBillingClient() {
    if (!subscriptionBilling) {
        subscriptionBilling = new SubscriptionBillingServicePromiseClient(host(), null, null);
    }
    return subscriptionBilling;
}

export function subscriptionPlansClient() {
    if (!subscriptionPlans) {
        subscriptionPlans = new SubscriptionPlansServicePromiseClient(host(), null, null);
    }
    return subscriptionPlans;
}

export function commercePartnersClient() {
    if (!commercePartners) {
        commercePartners = new CommercePartnersServicePromiseClient(host(), null, null);
    }
    return commercePartners;
}

export function usersClient() {
    if (!users) {
        users = new UsersServicePromiseClient(host(), null, null);
    }
    return users;
}
